import React from 'react';
import { Button } from './Button';
export function PainPoints() {
  const points = ['Domingo a la noche buscando cómo explicar while o funciones recursivas en un lenguaje que tus alumnos entiendan', 'Alumnos que entregan ejercicios perfectos generados por ChatGPT sin entender nada', 'Clases improvisadas porque los libros tienen ejemplos del año del ñaupa', 'Fines de semana enteros armando evaluaciones que nadie termina', 'Esa sensación de que los estás perdiendo y no sabés cómo engancharlos'];
  const failedSolutions = [{
    name: 'Los libros de didáctica:',
    desc: 'Pura teoría. Sin secuencias listas. Sin ejercicios.'
  }, {
    name: 'YouTube:',
    desc: 'Enseña a programar — no a enseñar programación.'
  }, {
    name: 'Grupos de Facebook:',
    desc: 'Materiales sueltos, sin progresión, muchas veces mal hechos.'
  }, {
    name: 'ChatGPT:',
    desc: 'Tus alumnos también lo usan para resolver los ejercicios. Empate.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-122">
      <div className="max-w-2xl mx-auto" data-id="element-123">
        <h2 className="text-xl md:text-2xl font-extrabold text-center mb-5 text-white leading-tight" data-id="element-124">
          Si enseñás <span className="text-brand-accent" data-id="element-125">Programación</span> o
          Tecnología en secundaria técnica, esto te va a sonar familiar:
        </h2>

        <div className="bg-brand-card rounded-2xl border border-white/10 p-4 md:p-5 mb-5" data-id="element-126">
          <div className="space-y-3" data-id="element-127">
            {points.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-128">
                <span className="text-red-400 shrink-0 text-base mt-0.5" data-id="element-129">
                  ❌
                </span>
                <p className="text-sm md:text-base text-gray-300 font-normal leading-relaxed" data-id="element-130">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <p className="text-center text-base md:text-lg font-semibold text-white mb-5" data-id="element-131">
          ¿Cuántos domingos más vale tu tiempo libre?
        </p>

        {/* Failed solutions */}
        <div className="bg-brand-card rounded-2xl border border-white/10 p-4 md:p-5 mb-5" data-id="element-132">
          <h3 className="text-sm md:text-base font-bold text-white mb-3 text-center uppercase tracking-tight" data-id="element-133">
            Lo que ya probaste y no funcionó:
          </h3>
          <div className="space-y-2.5" data-id="element-134">
            {failedSolutions.map((item, i) => <div key={i} className="flex items-start gap-2 text-xs md:text-sm" data-id="element-135">
                <span className="text-red-400 shrink-0 mt-0.5" data-id="element-136">×</span>
                <p className="text-gray-300 leading-relaxed" data-id="element-137">
                  <span className="font-semibold text-white" data-id="element-138">{item.name}</span>{' '}
                  {item.desc}
                </p>
              </div>)}
          </div>
          <p className="text-center text-sm md:text-base font-bold text-brand-accent mt-4 leading-tight" data-id="element-139">
            El problema no es que te falte información.
            <br data-id="element-140" />
            Es que nunca tuviste un sistema.
          </p>
        </div>

        <div className="w-full max-w-sm mx-auto" data-id="element-141">
          <Button className="text-sm md:text-base py-3.5" data-id="element-142">
            🚀 → QUIERO EL SISTEMA COMPLETO
          </Button>
        </div>
      </div>
    </section>;
}